import React, { useContext, useEffect, useState } from 'react'
import './Draft.css'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { mapData } from '@/product/common/components'
import ProductContext from '@/product/context/product/productContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'

function CommentModal(props) {
    const productContext = useContext(ProductContext)
    const { changeProductStatus, responseStatus: responseStatusProduct } =
        productContext

    const internalStatusFormik = useFormik({
        initialValues: {
            action: 'internal_status',
            project_id: [],
            status: '',
            notes: '',
            item_id: '',
            bprice: 0,
            asin_price: 0,
            date_closed: null,
            column: 'status',
            mainUpdate: false,
        },
        validationSchema: Yup.object({
            notes: Yup.string(),
            // .required('Required!'),
        }),
        onSubmit: (values) => {
            console.log('internalStatusFormik formData Child ', values)
            values.buynow = Number(values.bprice) > 0 ? 1 : 0
            changeProductStatus(values, 'internalStatusChange', true)
        },
    })

    useEffect(() => {
        if (props.internalStatusObj?.id) {
            const { id, status, item_id, bprice, asin_price, date_closed } =
                props.internalStatusObj
            internalStatusFormik.setFieldValue(`project_id`, [id])
            internalStatusFormik.setFieldValue(`status`, status)
            internalStatusFormik.setFieldValue(`item_id`, item_id)
            internalStatusFormik.setFieldValue(`bprice`, bprice)
            internalStatusFormik.setFieldValue(`asin_price`, asin_price)
            if (date_closed)
                internalStatusFormik.setFieldValue(`date_closed`, date_closed)
        }
    }, [props.internalStatusObj])

    const commentsData = [
        {
            label: 'Notes',
            name: 'notes',
            type: 'textarea',
            placeholder: 'Enter Notes',
            formik: internalStatusFormik,
        },
    ]
    return (
        <>
            <CustomDialog
                title={'Comments'}
                size="md"
                open={props.open}
                className={`lotNotes`}
                closeBtn={(e) => {
                    internalStatusFormik.setFieldValue('notes', '')
                    props.closeCommentPopup
                }}
                function={props.closeCommentPopup}
            >
                <div>
                    <form
                        onSubmit={internalStatusFormik.handleSubmit}
                        autoComplete="nofill"
                    >
                        {mapData(commentsData)}
                        <div className="text-center">
                            <PrimaryButton
                                id="inventory_update"
                                type="submit"
                                label="Submit"
                            />
                        </div>
                    </form>
                </div>
            </CustomDialog>
        </>
    )
}

export default CommentModal
